export const SegmentationsService = {
    /**
     * Filters posts by matching player personalized segmentation.
     * @param posts
     * @param playerSegments
     * @return {*}
     */
    filterPostsByPlayerSegments(posts, playerSegments) {
        return posts.filter(post => {
            const postSegmentation = post?.personalizedSegmentation;
            // No post segments - everyone match
            if (!postSegmentation || postSegmentation.length === 0) {
                return true;
            }

            // Player with no segments can't match any of post's segment
            if (!playerSegments || Object.keys(playerSegments).length === 0) {
                return false;
            }

            let segmentationPassed = false;
            for (const [segmentId, segments] of Object.entries(postSegmentation)) {
                if (segments.includes(playerSegments?.[segmentId])) {
                    segmentationPassed = true;
                    break;
                }
            }
            return segmentationPassed;
        });
    },
};
